
import apiEndPoints from "../../../routeConfig";
import { ApiService } from "../../../../service/api.service";

const apiService = new ApiService();

export const initiativeCreateOrUpdate = async (data, editMode, id,) => {
  let url
  let result
  if (editMode === true) {
    url = `${apiEndPoints.initiativeCreateOrUpdate}/${id}`
  } else {
    url = `${apiEndPoints.initiativeCreateOrUpdate}`
  }
  if (editMode === true) {
    await apiService.update(url, data).then(response => {
      result = response;
    }).catch(error => {
      result = error;
    })
  } else {
    await apiService.post(url, data).then(response => {
      result = response;
    }).catch(error => {
      result = error;
    })
  }
  return result;
}

export const getAllInitiative = async (page = 0, limit = 10) => {
  let result;
  await apiService
    .get(`${apiEndPoints.getAllInitiative}?page=${page + 1}&limit=${limit}`).then((response) => {
      result = response.data;
    })
    .catch((error) => {
      result = error;
    });
  return result;
};

export const initiativeGetById = async (id) => {
  let result;
  await apiService.get(`${apiEndPoints.initiativeGetById}/${id}`)
    .then((response) => {
      result = response.data;
    })
    .catch(error => {
      result = error;
    });
  return result;
};

export const deleteInitiative = async (id) => {
  try {
    const response = await apiService.patch(`${apiEndPoints.deleteInitiative}/${id}/status/DELETED`, '');
    return response;
  } catch (error) {
    return error;
  }
};

export const initiativePatchApi = async (id, statusUpdate) => {
  try {
    const response = await apiService.patch(`${apiEndPoints.initiativePatchApi}/${id}/status/${statusUpdate}`, '');
    return response;
  } catch (error) {
    return error;
  }
};

export const countryMetaData = async () => {
  let result;
  await apiService.get(`${apiEndPoints.countryMetaData}`)
    .then((response) => {
      result = response.data;
    })
    .catch(error => {
      result = error;
    });
  return result;
};

export const solutionMetaData = async () => {
  let result;
  await apiService.get(`${apiEndPoints.solutionMetaData}`)
    .then((response) => {
      result = response.data;
    })
    .catch(error => {
      result = error;
    });
  return result;
};
